;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('onLastRepeaterItem', onLastRepeaterItem)

  function onLastRepeaterItem () {
    function link (scope) {
      if (!scope.$parent.$last) {
        return
      }
      const fn = scope.onLastRepeaterItem()

      fn()
    }

    return {
      restrict: 'A',
      scope: {
        onLastRepeaterItem: '&'
      },
      link
    }
  }
})()
